<template>
<div v-if="isInsider" style="height:100%">
  <depart-list />
</div>
<div v-else style="height:100%;">
  <products-list style="padding: 20px 30px 12px;"/>
</div>
</template>
<script>
import ProductsList from './List';
import DepartList from './DepShare.vue'
import { isInnerUser } from "@/request/product.js";

export default {
  components: {
    ProductsList,
    DepartList
  },
  data() {
    return {
      isInsider: false,
    }
  },
  mounted(){
    isInnerUser().then(res=>{
      this.isInsider = res;
    })
  }
}
</script>
<style lang="">

</style>
